export default "__VITE_ASSET__DrCzMtjq__"